import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import gsap from 'gsap';

export type ScorecardsV2Tab = 'active' | 'completed';

@Component({
  selector: 'fgb-scorecards-v2-sub-nav',
  templateUrl: './scorecards-v2-sub-nav.component.html',
  styleUrl: './scorecards-v2-sub-nav.component.scss',
})
export class ScorecardsV2SubNavComponent implements AfterViewInit, OnDestroy {
  @Output() tabChange = new EventEmitter<ScorecardsV2Tab>();
  @ViewChild('indicator') indicatorRef!: ElementRef;
  @ViewChildren('tabBtn', { read: ElementRef }) tabBtns!: QueryList<ElementRef>;

  activeTab: ScorecardsV2Tab = 'active';
  private resizeTimeout: ReturnType<typeof setTimeout>;
  private initTimeout: ReturnType<typeof setTimeout>;

  @HostListener('window:resize')
  onResize(): void {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.positionIndicator(true));
  }

  ngAfterViewInit(): void {
    this.initTimeout = setTimeout(() => this.positionIndicator(true), 100);
  }

  ngOnDestroy(): void {
    clearTimeout(this.resizeTimeout);
    clearTimeout(this.initTimeout);
  }

  selectTab(tab: ScorecardsV2Tab): void {
    this.activeTab = tab;
    this.tabChange.emit(tab);
    this.positionIndicator(false);
  }

  private positionIndicator(instant: boolean): void {
    const btns = this.tabBtns?.toArray();
    if (!btns?.length || !this.indicatorRef) return;

    const tabIndex = this.activeTab === 'active' ? 0 : 1;
    const btn = btns[tabIndex]?.nativeElement;
    const indicator = this.indicatorRef.nativeElement;

    if (instant) {
      gsap.set(indicator, { x: btn.offsetLeft, width: btn.offsetWidth });
    } else {
      const tl = gsap.timeline();
      tl.to(indicator, {
        duration: 0.5,
        x: btn.offsetLeft,
        ease: 'back.out(1.2)',
        onStart: () => {
          gsap.to(indicator, { duration: 0.2, width: btn.offsetWidth, ease: 'power2.out' });
        },
      });
    }
  }
}
